import React, { useState } from 'react'
import { Collapse, IconButton } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import TableItem from '../TableItem/TableItem'
import './UnassignedOrders.scss'
export const UnassignedOrders = ({ orderRows }) => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prev) => !prev)
  }

  return (
    <div className='unassigned-orders-container'>
      <div className='unassigned-orders-header' onClick={handleToggle}>
        <span>Нераспределённые заказы</span>
        <IconButton size='small'>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
      </div>
      <Collapse sx={{ paddingBottom: '10px' }} in={open} timeout='auto' unmountOnExit>
        <Droppable droppableId='680ba0686f4f38c5062c45e5'>
          {(provided) => (
            <div className='unassigned-orders' ref={provided.innerRef} {...provided.droppableProps}>
              {orderRows.map(
                (order, index) =>
                  !order.logistic && (
                    <Draggable key={order._id} draggableId={order._id} index={index}>
                      {(provided) => (
                        <div className='order-card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                          <TableItem data={order} />
                        </div>
                      )}
                    </Draggable>
                  ),
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </Collapse>
    </div>
  )
}
